export default __webpack_public_path__ + "static/sfMono.7a2f7748.svg";